export default __webpack_public_path__ + "4a1ffe1b60fba2d2c4c8e56a9b3fb960.png";